module.exports = __webpack_public_path__ + "img/new-logo.d919b57b.png";